// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SettingsSkeleton_wrapper__1WZc1","buttons":"SettingsSkeleton_buttons__DA195","button":"SettingsSkeleton_button__1tR0H","checkBox":"SettingsSkeleton_checkBox__ckjUJ"};